export default "__VITE_ASSET__a57c6627__"